import React from 'react';

export default function Process() {
  const steps = [
    { number: "01", title: "Choose fabric", desc: "Select from our premium global collection." },
    { number: "02", title: "Get measured", desc: "Precise measurements by our master tailors." },
    { number: "03", title: "Get custom stitched", desc: "Experience the perfect fit and finish." }
  ];

  return (
    <section className="py-20 bg-[#faf9f6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-serif text-gray-900 mb-4">Our Process</h2>
          <div className="w-16 h-1 bg-[#d4af37] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-px bg-gray-300 -z-10 transform -translate-y-1/2"></div>
          
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center bg-white p-8 border border-gray-100 relative z-10">
              <div className="w-16 h-16 bg-[#d4af37] text-white rounded-full flex items-center justify-center text-2xl font-serif mb-6 shadow-md">
                {step.number}
              </div>
              <h3 className="text-xl font-bold mb-2 text-gray-900">{step.title}</h3>
              <p className="text-gray-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}